import { CONTENT_WIDTH } from "../../utils/pdfConstants";

export function renderKiinteistoRiskReportPdf({ content, data }) {
  const sections = data?.sections || [];

  if (!sections.length) {
    content.push({
      text: "Ei riskitietoja saatavilla.",
      style: "paragraph",
      bold: true,
      margin: [0, 5, 0, 10],
    });
    return;
  }

  const riskColorMap = {
    low: "#04aa00",
    medium: "#d0c407",
    high: "#ba3b46",
  };

  const tableLayout = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 3,
    paddingBottom: () => 3,
  };

  sections.forEach((section) => {
    // SECTION HEADER ROW
    const headerRow = [
      { text: section.title.toUpperCase(), bold: true },
      { text: "Riski", bold: true, alignment: "center" },
      { text: "Lisäselvitys", bold: true, alignment: "center" },
      { text: "Havaitut puutteet", bold: true },
    ];

    const body = [headerRow];

    section.rows.forEach((row) => {
      const hasRisk = !!row.risk;
      const riskMark = hasRisk ? "√" : "";
      const riskColor = riskColorMap[row.risk] || "#000";

      body.push([
        {
          text: row.name,
          bold: true,
        },
        {
          text: riskMark,
          color: riskColor,
          bold: true,
          fontSize: 15,
          alignment: "center",
        },
        {
          text: row.extra ? "x" : "",
          alignment: "center",
          bold: true,
        },
        {
          text: row.notes || "Ei kirjattuja havaintoja.",
        },
      ]);
    });

    content.push({
  table: {
    widths: ["30%", "10%", "15%", "45%"],
    body,
  },
  layout: {
    hLineWidth: function (i, node) {
      // Only draw line below header row
      return i === 1 ? 1 : 0;
    },
    hLineColor: function (i) {
      return i === 1 ? "#04aa00" : "#000";
    },
    vLineWidth: () => 0,
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 3,
    paddingBottom: () => 3,
  },
  margin: [0, 6, 0, 14],
});

  });
}
